import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverSalaryBulkEdit, DriverSalaryEdit, DriverSalaryRow } from '../../driver-salary-report.models';
import { RouteModalHandle } from '../../../route-function-report/route-analysis-report/route-analysis-report.models';
declare const $: (element: HTMLElement) => RouteModalHandle;
@Component({ selector: 'app-salary-edit-modal', templateUrl: './salary-edit-modal.component.html' })
export class SalaryEditModalComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() zoneReport = false;
  @Input() busy = false;
  @Input() errorMessage = '';
  @Output() save = new EventEmitter<{ bulk: boolean; value: DriverSalaryEdit | DriverSalaryBulkEdit }>();
  @ViewChild('root', { static: true }) root!: ElementRef<HTMLElement>;
  bulk = false;
  readonly form = new FormGroup({
    strStartTime: new FormControl('00:00', [Validators.required, Validators.pattern(/^([01]\d|2[0-3]):[0-5]\d$/)]),
    strEndTime: new FormControl('00:00', [Validators.required, Validators.pattern(/^([01]\d|2[0-3]):[0-5]\d$/)]),
    editStart: new FormControl(false), editEnd: new FormControl(false),
    iEncouragOvertime: new FormControl(null, Validators.min(0)), iIncentiveKm: new FormControl(null, Validators.min(0)),
    siServiceCharge: new FormControl(null, Validators.min(0)), iAttendanceDriver: new FormControl(null),
  });
  private phase: 'hidden' | 'opening' | 'shown' | 'closing' = 'hidden';
  private pendingHide = false;
  private destroyed = false;
  private focus?: HTMLElement;
  private readonly shown = () => { this.phase = 'shown'; if (this.pendingHide || this.destroyed) this.hide(); };
  private readonly hiding = () => { this.phase = 'closing'; };
  private readonly hidden = () => {
    this.phase = 'hidden'; this.pendingHide = false;
    if (this.destroyed) { this.dispose(); return; }
    this.zone.run(() => this.form.reset());
    this.focus?.focus();
  };
  constructor(private readonly zone: NgZone) {}
  ngOnChanges(): void { this.busy ? this.form.disable({ emitEvent: false }) : this.form.enable({ emitEvent: false }); }
  ngAfterViewInit(): void {
    const root = this.root.nativeElement;
    root.addEventListener('shown.bs.modal', this.shown); root.addEventListener('hide.bs.modal', this.hiding); root.addEventListener('hidden.bs.modal', this.hidden);
  }
  open(row: DriverSalaryRow | null): void {
    if (this.busy || this.destroyed || this.phase !== 'hidden') return;
    this.focus = document.activeElement instanceof HTMLElement ? document.activeElement : undefined;
    this.bulk = !row;
    this.form.reset({ strStartTime: row?.strStartTime?.slice(0, 5) || '00:00', strEndTime: row?.strEndTime?.slice(0, 5) || '00:00',
      editStart: false, editEnd: false, iEncouragOvertime: row?.iEncouragOvertime ?? null, iIncentiveKm: row?.iIncentiveKm ?? null,
      siServiceCharge: row?.siServiceCharge ?? null, iAttendanceDriver: row?.iAttendanceDriver ?? null });
    this.errorMessage = ''; this.pendingHide = false; this.phase = 'opening'; $(this.root.nativeElement).modal('show');
  }
  get canSave(): boolean { const value = this.form.getRawValue(); return !this.busy && this.form.valid && (!this.bulk || value.editStart || value.editEnd); }
  submit(): void {
    if (!this.canSave) return;
    const { editStart, editEnd, ...value } = this.form.getRawValue();
    this.save.emit({ bulk: this.bulk, value: this.bulk ? { strStartTime: editStart ? value.strStartTime : '', strEndTime: editEnd ? value.strEndTime : '' } : value });
  }
  hide(): void { if (this.phase === 'opening') this.pendingHide = true; else if (this.phase === 'shown') $(this.root.nativeElement).modal('hide'); }
  ngOnDestroy(): void { this.destroyed = true; if (this.phase === 'hidden') this.dispose(); else this.hide(); }
  private dispose(): void { const root = this.root.nativeElement; root.removeEventListener('shown.bs.modal', this.shown); root.removeEventListener('hide.bs.modal', this.hiding); root.removeEventListener('hidden.bs.modal', this.hidden); $(root).modal('dispose'); }
}
